import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=d24b3e4e&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d24b3e4e')) {
      api.createRecord('d24b3e4e', component.options)
    } else {
      api.reload('d24b3e4e', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=d24b3e4e&", function () {
      api.rerender('d24b3e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vwO1T0MersFh/JS/childrenage.vue"
export default component.exports